module.exports = __webpack_public_path__ + "static/media/onboardingframe.d477186a.png";